import React, { memo } from "react";
import InputBox from "../Components/InputBox";
import {
  FaMoneyBillWave,
  FaCalendarAlt,
  FaUsers,
  FaCreditCard,
  FaDollarSign,
} from "react-icons/fa";
import { MdPayment } from "react-icons/md";

const InfoCard = ({ title, icon: Icon, children }) => (
  <div className="bg-white rounded-lg border border-gray-100 p-4 shadow-sm">
    <div className="flex items-center gap-2 mb-3">
      <Icon className="w-4 h-4 text-[#363062]" />
      <h3 className="text-sm font-medium text-[#363062]">{title}</h3>
    </div>
    <div className="space-y-2">{children}</div>
  </div>
);

const InfoItem = ({
  label,
  value,
  editValue,
  name,
  type = "text",
  icon: Icon,
  onChange,
  editMode,
}) => (
  <div className="flex items-start justify-between group">
    <div className="flex items-center gap-1.5">
      {Icon && <Icon className="w-3.5 h-3.5 text-gray-400" />}
      <span className="text-xs text-gray-500">{label}</span>
    </div>
    {editMode ? (
      <InputBox
        value={editValue}
        onChange={onChange}
        name={name}
        type={type}
        className="w-48 text-right bg-[#363062]/5 border-[#363062]/20 focus:border-[#363062] focus:ring-1 focus:ring-[#363062] transition-colors duration-200 px-3 py-1.5"
      />
    ) : (
      <span className="text-sm font-medium text-gray-900">
        {type === "number" && name === "monthlyLeaseRate" ? "₱ " : ""}
        {value}
        {type === "number" && name === "monthsDeposit" ? " months" : ""}
        {type === "number" && name === "monthsAdvance" ? " months" : ""}
      </span>
    )}
  </div>
);

const TenancyInformationForm = memo(
  ({ tenant, formData, editMode, onChange, onSubmit }) => {
    return (
      <form onSubmit={onSubmit} className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {/* Payment Information */}
          <InfoCard title="Lease Payments" icon={FaDollarSign}>
            <InfoItem
              label="Monthly Lease Rate"
              value={tenant.monthlyLeaseRate}
              editValue={formData.monthlyLeaseRate}
              name="monthlyLeaseRate"
              type="number"
              icon={FaMoneyBillWave}
              onChange={onChange}
              editMode={editMode}
            />
            <InfoItem
              label="Months Deposit"
              value={tenant.monthsDeposit}
              editValue={formData.monthsDeposit}
              name="monthsDeposit"
              type="number"
              icon={FaCalendarAlt}
              onChange={onChange}
              editMode={editMode}
            />
            <InfoItem
              label="Months Advance"
              value={tenant.monthsAdvance}
              editValue={formData.monthsAdvance}
              name="monthsAdvance"
              type="number"
              icon={FaCalendarAlt}
              onChange={onChange}
              editMode={editMode}
            />
          </InfoCard>

          {/* Additional Information */}
          <InfoCard title="Additional Details" icon={MdPayment}>
            <InfoItem
              label="Mode of Payment"
              value={tenant.modeOfPayment}
              editValue={formData.modeOfPayment}
              name="modeOfPayment"
              icon={FaCreditCard}
              onChange={onChange}
              editMode={editMode}
            />
            <InfoItem
              label="Allowed Occupants"
              value={tenant.allowedOccupants}
              editValue={formData.allowedOccupants}
              name="allowedOccupants"
              type="number"
              icon={FaUsers}
              onChange={onChange}
              editMode={editMode}
            />
          </InfoCard>
        </div>
      </form>
    );
  }
);

export default TenancyInformationForm;
